import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

function onError(error: unknown) {
  const typedError = error as Error | AxiosError;
  if ('isAxiosError' in typedError) {
    const status = typedError.response?.status ?? 0;

    if (status === 401) {
      document.location.reload();
    } else {
      const data = typedError.response?.data ?? {};
      console.error(status, data);
      console.error(status, JSON.stringify(data));
    }
  }
}

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({ onError }),
  queryCache: new QueryCache({ onError }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (count: number, error: unknown) => {
        if (count >= 2) return false;
        if (!error || typeof error !== 'object' || !('isAxiosError' in error)) return false;
        const status = (error as AxiosError).response?.status;
        if (typeof status !== 'number') return false;
        if (status >= 500 && status <= 599) return true;
        return false;
      },
    },
  },
});
